import { stateOptions, canadaStateOptions, countryOptions } from "Root/data";
import httpService from "Root/api/httpService";
import { heightConverter, ftInToMCm, lbToKG } from "Root/helpers/util";
import { getSnoozeOrderDate, prepareDateToPost, } from "Root/profile/components/SubscriptionPageV2/utils";
// profile common
export async function apiGetUserData() {
    const endpoint = "/api/v2/user-data/";
    const data = await httpService.get(endpoint);
    return {
        ...data,
        name: data.name.split(" ")[0],
        full_name: data.name,
    };
}
export const apiAddUserAction = (action, item) => {
    const endpoint = "/users/userAction/";
    return httpService.post(endpoint, { action, item });
};
// profile common
// cancel subscription
export const apiGetCancelReasons = () => {
    const endpoint = "/api/cancel-reasons/";
    return httpService.get(endpoint);
};
export const apiGetNumberOfOrders = () => {
    const endpoint = "/api/get-num-orders/";
    return httpService.get(endpoint);
};
export const apiGetArticles = () => {
    const endpoint = "/api/v2/articles/";
    return httpService.get(endpoint);
};
export const apiGetCancelTestStatus = (reason) => {
    const endpoint = `/users/getCancelTestStatus/?reason=${reason}`;
    return httpService.get(endpoint);
};
export const apiSkipOrder = (body) => {
    const endpoint = "/api/v2/skip-order/";
    return httpService.post(endpoint, body);
};
export const apiSkipProducts = (body) => {
    const endpoint = "/users/skip_products/";
    return httpService.post(endpoint, body);
};
export const apiUnsubscribe = (body) => {
    const endpoint = "/users/unsubscribe/";
    return httpService.post(endpoint, body);
};
export const apiGetCancelHelp = (body) => {
    const endpoint = "/users/getCancelHelp/";
    return httpService.post(endpoint, body);
};
export const apiAddAdditionalItemToNextOrder = (body) => {
    const endpoint = "/api/v2/add-additional-item-to-next-order/";
    return httpService.post(endpoint, body); // not tested 500 (Internal Server Error): AttributeError at /api/v2/add-additional-item-to-next-order/ 'str' object has no attribute 'get'
};
// account settings
const splitName = (name) => ({
    firstName: name.split(" ")[0] || "",
    lastName: name.split(" ")[1] || "",
});
export async function apiGetUserAccount() {
    const endpoint = "/api/v2/user-account/";
    const data = await httpService.get(endpoint);
    const shippingDataObjForCompare = { ...data.shipping_data };
    delete shippingDataObjForCompare.address2;
    data.sameAddress =
        JSON.stringify(shippingDataObjForCompare) ===
            JSON.stringify(data.billing_data);
    data.billing_data.firstName = splitName(data.billing_data.name).firstName;
    data.billing_data.lastName = splitName(data.billing_data.name).lastName;
    data.shipping_data.firstName = splitName(data.shipping_data.name).firstName;
    data.shipping_data.lastName = splitName(data.shipping_data.name).lastName;
    data.billing_data.address2 = data.shipping_data.address2;
    data.firstName = splitName(data.name).firstName;
    data.lastName = splitName(data.name).lastName;
    return data;
}
export function apiGetStripeKeys() {
    const endpoint = "/api/stripe-keys/"; // common for checkout and profile
    return httpService.get(endpoint);
}
export function apiUpdateDefaultCard(body) {
    const endpoint = "/users/change_default_card/";
    return httpService.post(endpoint, body);
}
export function apiAddCard(body) {
    const endpoint = "/users/add_card/";
    return httpService.post(endpoint, body);
}
export function getCountryOption() {
    return countryOptions.map((item) => ({
        value: item.value,
        label: item.text,
    }));
}
export function getStateOptions(country) {
    if (country === "CA") {
        return canadaStateOptions.map((item) => ({
            value: item.text,
            label: item.text,
        }));
    }
    return stateOptions.map((item) => ({ value: item.text, label: item.text }));
}
export function apiRemoveCard(body) {
    const endpoint = "/users/delete_card/";
    return httpService.post(endpoint, body);
}
export function apiGetCommunicationPrefs() {
    const endpoint = "/api/v2/communication-prefs/";
    return httpService.get(endpoint);
}
export function apiUpdateCommunicationPrefs(userAccount, name, value) {
    const body = {
        email: userAccount.email,
        email_optin: "false",
        sms_number: userAccount.phone,
        sms_optin: "false",
    };
    if (name === "email_opt_in" && value) {
        body.email_optin = value.toString();
    }
    if (name === "sms_opt_in" && value) {
        body.sms_optin = value.toString();
    }
    const endpoint = "/users/update_comm_settings/";
    return httpService.post(endpoint, body);
}
export function apiUpdateAccountData(body) {
    const billingData = {
        ...body.billing_data,
        name: `${body.billing_data.firstName} ${body.billing_data.lastName}`,
    };
    const shippingData = {
        ...body.shipping_data,
        name: `${body.shipping_data.firstName} ${body.shipping_data.lastName}`,
    };
    const accountData = {
        billing_data: billingData,
        shipping_data: shippingData,
        name: `${body.firstName} ${body.lastName}`,
        email: body.email,
        phone: body.phone,
        verify: body.verify,
    };
    const endpoint = "/api/v2/update-account-data/";
    return httpService.post(endpoint, accountData);
}
export function apiUpdateUserPassword(body) {
    const endpoint = "/users/change_password/";
    return httpService.post(endpoint, body);
}
// account settings
// dietitian page
export function apiGetDietitian() {
    const endpoint = "/api/get-rd-info/";
    return httpService.get(endpoint);
}
export function apiGetMacroAnswers() {
    const endpoint = "/api/v2/macro-answers/";
    return httpService.get(endpoint);
}
export function apiGetPreviousMessages() {
    const endpoint = "/api/get-previous-rd-messages/";
    return httpService.get(endpoint);
}
export function apiSendMessageToRD(body) {
    const endpoint = "/api/ask-dietitian/";
    return httpService.post(endpoint, body);
}
// dietitian page
export function apiBuySubscriptionItemsNow(body = {}) {
    const endpoint = "/users/resume_subscription/";
    return httpService.post(endpoint, body);
}
export function apiUpdateItemQuantity(userCart) {
    const preparedBody = userCart
        .map((item) => {
        if (item?.bags_info.length) {
            return item.bags_info.map((bag) => ({
                quantity: bag.quantity,
                sku: bag.sku,
            }));
        }
        return [
            {
                quantity: item.quantity,
                sku: item.sku,
            },
        ];
    })
        .flat();
    const endpoint = "/api/v2/update-item-quantity/";
    return httpService.post(endpoint, preparedBody);
}
export function apiGetItNow(userCart) {
    const preparedBody = userCart
        .map((product) => {
        const items = [...new Set(product.bags_info.map((item) => item.sku))];
        if (items.length > 1) {
            return product.bags_info.map((item) => ({
                item: item.sku,
                quantity: item.quantity,
            }));
        }
        const bag = product.bags_info.length ? product.bags_info[0] : null;
        return bag && [{ item: bag.sku, quantity: bag.quantity }];
    })
        .filter((item) => item)
        .flat();
    const endpoint = "/api/v2/get-it-now/";
    return httpService.post(endpoint, preparedBody);
}
export function resumeSubscription() {
    const endpoint = "/api/v2/resume-subscription/";
    return httpService.post(endpoint);
}
export async function apiUpdatePricing(userCart) {
    const body = userCart.map((item) => ({
        sku: item.sku,
        quantity: Number(item.quantity),
    }));
    const endpoint = "/api/v2/pre-calculate-order/";
    const data = await httpService.post(endpoint, body);
    const filteredPricing = data.lineItems.filter((item) => item.line_item_name !== "BlenderBottle" &&
        item.line_item_name !== "Water Bottle");
    return { lineItems: filteredPricing, user_cart: data.user_cart };
}
// get it now
// how to LP
export function apiGetHowToLPData() {
    const endpoint = "/api/v2/get-how-to-use-data/"; // common for checkout and profile
    return httpService.get(endpoint);
}
// how to LP
// my profile
export async function apiGetAnswers() {
    const endpoint = "/api/v2/get-all-quiz-answers/";
    const data = await httpService.get(endpoint);
    const [calculatedFeet, calculatedInches] = heightConverter("-1", `${data.selected_answers.height}`);
    const modifiedAnswersObj = {
        ...data.selected_answers,
        ft: calculatedFeet,
        inch: calculatedInches,
        m: ftInToMCm(calculatedFeet, calculatedInches)[0],
        cm: ftInToMCm(calculatedFeet, calculatedInches)[1],
        weightKG: lbToKG(data.selected_answers.weight),
        goalWeightKG: lbToKG(data.selected_answers.goalWeight),
    };
    if (data.selected_answers.mainExercises) {
        modifiedAnswersObj.primaryExercise = data.selected_answers.mainExercises
            .length
            ? data.selected_answers.mainExercises[0].trim()
            : "";
        modifiedAnswersObj.secondaryExercise =
            data.selected_answers.mainExercises.length > 1
                ? data.selected_answers.mainExercises[1].trim()
                : "";
    }
    return { modifiedAnswersObj, data };
}
export function apiUpdateAnswers(body) {
    const endpoint = "/api/update-answers/";
    return httpService.post(endpoint, body);
}
// my profile
// order history
export function apiGetOrdersHistory(offset) {
    let endpoint = "/api/v2/get-order-history/";
    if (offset !== 0) {
        endpoint = `${endpoint}?offset=${String(offset)}`;
    }
    return httpService.get(endpoint);
}
// order history
export function apiGetReferalInfo(email) {
    const endpoint = "/api/get-referral-data/" + (email ? `?${email}` : "");
    return httpService.get(endpoint);
}
export function apiSendReferalEmail(body) {
    const endpoint = "/users/sendReferralEmail/";
    return httpService.post(endpoint, body);
}
export function apiSendMultipleReminders(body) {
    const endpoint = "/users/sendMultipleReminders/";
    return httpService.post(endpoint, body);
}
// referal page
// subscription page
export function apiGetOrderDetails(key) {
    const endpoint = `/api/v2/order-details/${key ? `?${key}` : ""}`;
    return httpService.get(endpoint);
}
export function apiGetOrderStatusData() {
    const endpoint = "/api/v2/get-order-status-data/";
    return httpService.get(endpoint);
}
export function apiGetShippingAddress() {
    const endpoint = "/api/get-shipping-info/";
    return httpService.get(endpoint);
}
export function apiGetPaymentInfo() {
    const endpoint = "/api/get-payment-info/";
    return httpService.get(endpoint);
}
export function apiGetReactivationModules() {
    const endpoint = "/api/v2/get-reactivation-modules/";
    return httpService.get(endpoint);
}
export function apiGetUserCart() {
    const endpoint = "/api/v2/get-user-cart/";
    return httpService.get(endpoint);
}
export function apiGetMissingAdddons() {
    const endpoint = "/api/get-missing-addons/";
    return httpService.get(endpoint);
}
export function apiGetProductData(currentProduct) {
    const endpoint = `/api/get-product-info/?product=${currentProduct}`;
    return httpService.get(endpoint);
}
export function apiGetAvailableFlavors(name) {
    const endpoint = `/api/get-available-flavors/?product=${name}`;
    return httpService.get(endpoint);
}
export function apiGetAllAvailableFlavors() {
    const endpoint = "/api/get-flavors-for-profile/"; // common for checkout and profile
    return httpService.get(endpoint);
}
export function apiGetSelectedFlavors(name) {
    const endpoint = `/api/get-flavors?product=${name}`;
    return httpService.get(endpoint);
}
export function apiGetProteinPrices() {
    const endpoint = "/api/v2/get-protein-prices/";
    return httpService.get(endpoint);
}
export async function apiGetPricingSummary() {
    const endpoint = "/api/v2/pre-calculate-order/";
    const data = await httpService.get(endpoint);
    const filteredPricing = data.lineItems.filter((item) => item.line_item_name !== "BlenderBottle" &&
        item.line_item_name !== "Water Bottle");
    return {
        lineItems: filteredPricing,
        discount_str: data.discount_str,
        user_cart: data.user_cart,
        recurring_discount_str: data.recurring_discount_str,
        banner_text: data.banner_text,
        referral_data: data.referral_data,
    };
}
export async function apiPrecalculateOrder(cart) {
    const preparedBody = cart
        .map((product) => {
        const items = [...new Set(product.bags_info.map((item) => item.sku))];
        if (items.length > 1) {
            return product.bags_info.map((item) => ({
                item: item.sku,
                quantity: item.quantity,
            }));
        }
        const bag = product.bags_info.length ? product.bags_info[0] : null;
        return bag && [{ item: bag.sku, quantity: bag.quantity }];
    })
        .filter((item) => item)
        .flat();
    const endpoint = "/api/v2/get-it-now-pricing-summary/";
    const data = await httpService.post(endpoint, preparedBody);
    const filteredPricing = data.pricing_summary.filter((item) => item.line_item_name !== "BlenderBottle" &&
        item.line_item_name !== "Water Bottle");
    return filteredPricing;
}
export function apiDeleteLineItem(body) {
    const endpoint = "/api/v2/remove-line-item/";
    return httpService.post(endpoint, body);
}
export const apiApplyPromo = (body) => {
    const endpoint = "/api/v2/apply-promo/";
    return httpService.post(endpoint, body, true);
};
export const apiDeletePromo = (body) => {
    const endpoint = "/api/v2/remove-promo/";
    return httpService.post(endpoint, body, true);
};
export function apiAddLineItem(body, reduxBody) {
    const attributesObject = {};
    let newBody = {};
    if (body) {
        if (body.item === "hydration") {
            attributesObject.hydration_caffeinated = body.attributes.hydration.find((item) => item.attribute_name === "hydration_caffeinated")?.attribute_on;
            attributesObject.sweat_level = null;
            attributesObject.flavor = body.flavors[0].short_name;
        }
        if (body.item === "preworkout") {
            attributesObject.preworkout_caffeinated = body.attributes.preworkout.find((item) => item.attribute_name === "preworkout_caffeinated")?.attribute_on;
            attributesObject.wantsCreatine = body.attributes.preworkout.find((item) => item.attribute_name === "wantsCreatine")?.attribute_on;
            attributesObject.flavor = body.flavors[0].short_name;
        }
        newBody = {
            item: body.item,
            attributes: attributesObject,
            flavors: body.flavors,
            quantity: body.quantity,
        };
    }
    const endpoint = "/api/v2/add-additional-item-to-next-order/";
    return httpService.post(endpoint, reduxBody || newBody);
}
export function apiGetFutureOrders() {
    const endpoint = "/api/future-orders/";
    return httpService.get(endpoint);
}
export function apiSetFutureOrders(body) {
    const endpoint = "/api/future-orders/";
    return httpService.post(endpoint, body);
}
export function apiGetNextOrderDates() {
    const endpoint = "/api/get-next-order-dates/";
    return httpService.get(endpoint);
}
export function apiGetBannerData() {
    const endpoint = "/api/v2/get-banner/";
    return httpService.get(endpoint);
}
export function apiGetRDModal(queryParams) {
    const endpoint = "/api/v2/get-rd-modal/";
    return httpService.get(endpoint + queryParams);
}
export function apiUpdateCadence(body) {
    const endpoint = "/api/v2/update-cadence/";
    return httpService.post(endpoint, body);
}
export function apiPostNewOrderDate(body) {
    const endpoint = "/users/new_order_date/ ";
    return httpService.post(endpoint, body);
}
export function apiUpdateCartItemsProperties(body) {
    const endpoint = "/api/v2/update-quantity-flavor-attributes/";
    return httpService
        .post(endpoint, body)
        .then((data) => ({
        error: data.error,
        userCart: data.userCart.map((item) => ({ ...item })),
    }));
}
export function apiSnoozeOrder(week, nextOrderData) {
    const dateObj = {
        year: nextOrderData.nextShipmentYear,
        day: nextOrderData.nextShipmentDay,
        month: nextOrderData.nextShipmentMonth,
    };
    const body = {
        reason: "",
        new_date: prepareDateToPost(getSnoozeOrderDate(week, dateObj)),
    };
    const endpoint = "/users/new_order_date/";
    return httpService.post(endpoint, body);
}
export function apiGetMangoModal() {
    return httpService.get("/api/get-mango-modal/");
}
export function apiGetGreensModal() {
    return httpService.get("/api/get-greens-modal/");
}
// // subscription page
export function apiGetUpsellingModule() {
    const endpoint = "/api/v2/get-personalized-upsell-recommendations/";
    return httpService.get(endpoint);
}
export function apiAcceptPriceIncrease() {
    const endpoint = "/api/v2/accept-price-increase/";
    return httpService.post(endpoint, {});
}
export function apiApplyRewardsPoints(points) {
    const endpoint = "/api/v2/apply-rewards-points/";
    return httpService.post(endpoint, { points: points });
}
export function apiRemoveRewardsPoints() {
    const endpoint = "/api/v2/remove-rewards-points/";
    return httpService.post(endpoint, {});
}
export function apiCalculateMacros(body) {
    const endpoint = "/api/calories-and-macros/";
    return httpService.post(endpoint, body);
}
export function apiFetchMacros() {
    const endpoint = "/api/calories-and-macros/";
    return httpService.get(endpoint);
}
export function apiCreateGiftCardPaymentIntent(amount) {
    const endpoint = "/api/v2/create-gift-card-pi/";
    return httpService.post(endpoint, { amount: amount });
}
export function getRewardsOptInCohort() {
    const endpoint = "/api/rewards-opt-in-ab/";
    return httpService.get(endpoint);
}
export function postRewardsOptIn() {
    const endpoint = "/api/rewards-opt-in-ab/";
    return httpService.post(endpoint);
}
export function apiGetCancelData() {
    const endpoint = "/api/v2/apply-cancel-promo/";
    return httpService.get(endpoint);
}
export function apiGetCancelABTest(cancelReason) {
    const endpoint = `/api/v2/get-ab-status/cancel_offer/?cancel_reason=${cancelReason}`;
    return httpService.get(endpoint);
}
export function apiApplyCancelPromo(body) {
    const endpoint = "/api/v2/apply-cancel-promo/";
    return httpService.post(endpoint, body);
}
export function apiGetPostPurchaseData() {
    const endpoint = "/api/v2/post-purchase-data/";
    return httpService.get(endpoint);
}
export function apiCountReferralClick() {
    const endpoint = "/api/count-referral-click/";
    return httpService.post(endpoint);
}
export function apiGetPrices() {
    const endpoint = "/api/v2/get-all-prices/";
    return httpService.get(endpoint);
}
export function getMemberPerks(perkId) {
    const endpoint = `/api/member-perks/?perk_id=${perkId}`;
    return httpService.get(endpoint);
}
export function postMemberPerks(body) {
    const endpoint = "/api/member-perks/";
    return httpService.post(endpoint, body);
}
export function memberPerkPromo(body) {
    const endpoint = "/api/member-perk-promo/";
    return httpService.post(endpoint, body);
}
export function completeBannerEvent(body) {
    const endpoint = "/api/complete-banner-event/";
    return httpService.post(endpoint, body);
}
